// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/competitions/:id/leaderboard\",\"regex\":\"^/competitions/([^/]+)/leaderboard$\",\"paramNames\":[\"id\"]}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/admin\"},{\"path\":\"/admin/competitions\"},{\"path\":\"/admin/users\"},{\"path\":\"/competitions\"},{\"path\":\"/competitions/history\"},{\"path\":\"/dashboard\"},{\"path\":\"/leaderboard\"},{\"path\":\"/auth/dev-access\"},{\"path\":\"/auth/email-verified\"},{\"path\":\"/auth/error\"},{\"path\":\"/auth/forgot-password\"},{\"path\":\"/auth/login\"},{\"path\":\"/auth/sign-up\"},{\"path\":\"/auth/sign-up-success\"},{\"path\":\"/auth/update-password\"},{\"path\":\"/contact\"},{\"path\":\"/onboarding\"}]}";globalThis["_sentryNextJsVersion"] = "16.1.1";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://0e6c712fa1cba95b30044cf8cb59a573@o4510056196669440.ingest.us.sentry.io/4510056197521408",

  // Add optional integrations for additional features
  integrations: [
    Sentry.replayIntegration(),
  ],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;